export class Iban {
  id: number;
  iban: string;
  verified: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  loading = false;
  errors: any = {};

  constructor(input: any = {}) {
    this.iban = input.iban?.split('IR')[1] ?? undefined;
    this.verified = input.verified;
    this.id = input.id;
  }
}
